export const DISCOUNT_TYPES = [
    { 
      value: 'EURO',
      label: '€'
    },
    {
      value: 'PERCENT',
      label: '%'
    }
];